/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


export class GcpBigQueryResourceRoutinesInner {
  /**
  * Routine name.
  */
  'name'?: string;
  /**
  * Routine type.
  */
  'type'?: string;
  /**
  * Programming language of the routine.
  */
  'language'?: string;
  /**
  * Routine creation time.
  */
  'creationTime'?: Date;
  /**
  * Routine last modification time.
  */
  'lastModifiedTime'?: Date;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "name",
      "baseName": "name",
      "type": "string",
      "format": ""
    },
    {
      "name": "type",
      "baseName": "type",
      "type": "string",
      "format": ""
    },
    {
      "name": "language",
      "baseName": "language",
      "type": "string",
      "format": ""
    },
    {
      "name": "creationTime",
      "baseName": "creationTime",
      "type": "Date",
      "format": "date-time"
    },
    {
      "name": "lastModifiedTime",
      "baseName": "lastModifiedTime",
      "type": "Date",
      "format": "date-time"
    }  ];

  static getAttributeTypeMap() {
    return GcpBigQueryResourceRoutinesInner.attributeTypeMap;
  }

  public constructor() {
  }
}

